<app-organization-menu [id]="currentOrganizationId"></app-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <h4 class="border-bottom pb-2 color-primary mb-3">{{'ORGANIZATION.PRICES.title' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            {{'ORGANIZATION.PRICES.titleHelpText' | translate}}
        </small>
    </h4>
    <div class="row">
        <div class="col-12 col-sm-6 py-4">
            <div class="form-group">
                <label>{{'GENERAL.italian' | translate}}</label>
                <quill-editor id="description_it" name="description_it" [(ngModel)]="price.price_it"
                    [styles]="{height: '250px'}">
                </quill-editor>
                <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                        [icon]="icons['faLink']"></fa-icon>
                    {{'GENERAL.richTextFielHelpText2' | translate}}</small>
            </div>
        </div>
        <div class="col-12 col-sm-6 py-4">
            <div class="form-group">
                <label>{{'GENERAL.german' | translate}}</label>
                <quill-editor id="description_de" name="description_de" [(ngModel)]="price.price_de"
                    [styles]="{height: '250px'}">
                </quill-editor>
                <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                        [icon]="icons['faLink']"></fa-icon>
                    {{'GENERAL.richTextFielHelpText2' | translate}}</small>
            </div>
        </div>
        <div class="col-12 col-sm-6 py-4">
            <div class="form-group">
                <label>{{'GENERAL.english' | translate}}</label>
                <quill-editor id="description_en" name="description_en" [(ngModel)]="price.price_en"
                    [styles]="{height: '250px'}">
                </quill-editor>
                <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                        [icon]="icons['faLink']"></fa-icon>
                    {{'GENERAL.richTextFielHelpText2' | translate}}</small>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col text-end">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="onSavePriceButtonClick()">
                {{'GENERAL.save' | translate}}
            </button>
        </div>
    </div>
</div>
<app-toast></app-toast>
